// Centralized asset URLs (self-hosted under /images)
import sealImg from './img/seal-fuyangtong.png';

export const ASSETS = {
  seal: sealImg,
  logo: '/images/logo.png',
  aboutExhibition: '/images/about-exhibition.jpg',
  aboutInterview: '/images/about-interview.jpg',
  aboutMaster: '/images/about-master.jpg',
  heroEaves: '/images/hero-bg.jpg',
  inkMountain: '/images/ink-mountain.jpg',
  warmStones: '/images/warm-stones.jpg',
  goldOrnament: '/images/gold-ornament.jpg',
  ancientManuscript: '/images/ancient-manuscript.jpg',
} as const;

export default ASSETS;
